/**
 * @desc Imagry layers to import into the store
 *
 * @author Mike Hamilton <mike@mikehamilton.ca>
 */

export default {
  state: {
    name: "summer10m2014Muni",
    layerTitle: "Summer 2014 (10 cm)",
    visibility: false
  }
};
